import React,{useContext} from 'react'
import RootContext from '../../context/RootContext';
import OpenNewTab from '../../hooks/OpenNewTab'
import './Footer.css'

const Footer = () => {
  const {year} = useContext(RootContext)
  const {openInNewTab} = OpenNewTab();
  return (
    <div className="footer-container text-white py-2 bg-ash">
      <div className="text-center text-muted px-1">
        <small style={{fontSize: '12px'}}>COPYRIGHT &copy; 2012 - {year} ALL RIGHTS RESERVED BY KYAU || THIS ONLINE ADMISSION SYSTEM IS DESIGNED, DEVELOPED, AND MAINTAINED BY <span className='text-tomato cursor-pointer text-decoration-underline' onClick={(e) => openInNewTab("https://miltonhossain.netlify.app/")} title='Click to see about Developer'>IQAC IT CELL, KYAU</span></small>
      </div>
    </div>
  )
}

export default Footer